import { RecordBase } from '../../providers/request/record-base.model';
import { ArchiveTitleRuleItemInfo } from './archive-title-rule-item-info.model';
export class ArchiveTitleRule extends RecordBase {
  projectId?: number;
  titleFixedPrefix?: string;
  titleAutoParts?: Array<ArchiveTitleRuleItemInfo>;
  titleFixedSuffix?: string;
  titleExample?: string;
  forceUpdate?: boolean;
}
